import { useMediaQuery } from "@mantine/hooks";

/**
 * Single source of truth for the "mobile" breakpoint. 48em (768px) == Mantine `sm` == the
 * AppShell navbar breakpoint (App.jsx), so JS branches and CSS layout (hiddenFrom/visibleFrom,
 * responsive {base, sm} props) stay in lock-step.
 *
 * Prefer CSS-driven responsiveness where it can express the change; reach for this hook only for
 * genuine structural branches CSS can't do (inline↔Drawer, fullScreen modal, drag-and-drop↔list).
 * getInitialValueInEffect:false computes the match on the first client render (this is a Vite SPA,
 * no SSR) so a structural branch doesn't flash the wrong layout on load.
 *
 * Boundary is 47.99375em, NOT 48em: Mantine's hiddenFrom/visibleFrom/AppShell use the "-0.1px" rule
 * (sm hides at max-width 47.99375em), so a plain max-width:48em would return `true` at exactly 768px
 * while the CSS shows desktop — a mixed layout on iPad portrait. This keeps JS and CSS in lock-step.
 */
export function useIsMobile() {
  return useMediaQuery("(max-width: 47.99375em)", false, { getInitialValueInEffect: false });
}

export default useIsMobile;
